/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Video_LockInputs */



/**
* | output |
* | --- |
* | "Toggle Video Lock" |
*
* @param {Shortcut_Keys_Name_Toggle_Video_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_video_lock = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Video_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Video_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer verrouillage video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videosperre umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva blocco video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить блокировку видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar el bloqueo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换视频锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオロックの切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो लॉक टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar bloqueio de vídeo")
	return /** @type {LocalizedString} */ ("Toggle Video Lock")
});